import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=b8628e10&scoped=true"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=b8628e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8628e10",
  null
  
)

export default component.exports